import React, { FunctionComponent, useEffect, useState } from "react";
import { fetchHotMovie } from "@Services/api";
import { useQuery } from "react-query";
import styles from "./index.module.less";

interface IProps {
  limit?: number
}

const ArticlesRank: FunctionComponent<IProps> = ({limit = 5}) => {
  const [data, setData] = useState<any>([]);

  const fetch = async () => {
    try {
      const res = await fetchHotMovie({ limit });
      setData(res.data.list);
    } catch (error) {}
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <>
      {data.length > 0 && (
        <div className={styles["hot-movie"]}>
          <p className={styles["title"]}>熱門影片</p>

          <div className={styles["hot-list"]}>
            {data.map((item) => (
              <a key={item.id} title={item.title} href={item.link} target='_blank' className={styles["hot-item"]}>
                <div className={styles["img-box"]}>
                  <img src={item.imgUrl} alt={item.title} />
                  <span className={styles["img-time"]}>{item.playTime}</span>
                </div>

                <div className={styles["desc-box"]}>
                  <div className={styles["movie-title"]}>{item.title}</div>

                  <div className={styles["desc"]}>播放：{item.playNum}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ArticlesRank;
